import { render, staticRenderFns } from "./ProspectusList.vue?vue&type=template&id=2454a6ac&scoped=true"
import script from "./ProspectusList.vue?vue&type=script&lang=js"
export * from "./ProspectusList.vue?vue&type=script&lang=js"
import style0 from "./ProspectusList.vue?vue&type=style&index=0&id=2454a6ac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2454a6ac",
  null
  
)

export default component.exports